import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';
import Headline from '../../atoms/headline/headline';
import Copy from '../../atoms/copy/copy';
import Image from '../../atoms/image/image';
import { LongArrowRight } from '../../icons/arrow/arrow';

import StyledArticleTeaser from './articleTeaser.style';
import FilterTags from '../../atoms/filter-tags/filterTags';
import Tags from '../../atoms/tags/tags';
import DigitalContentIcon from '../../icons/digitalContent.svg';
import MixedCopy from '../mixed-copy/mixedCopy';

const imageSizes = [
  {
    condition: 'min-width: 980px',
    width: '30vw'
  },
  {
    condition: 'min-width: 450px',
    width: '45vw'
  },
  {
    width: '100vw'
  }
];

const ArticleTeaser = props => {
  const {
    pageTags,
    typeTags,
    copy,
    introCopy,
    headline,
    image,
    imageFormat,
    size = 'm',
    subline,
    uri,
    fullWidth = false,
    alignment = 'left',
    id,
    category
  } = props;

  // Check if typeTags contain tags starting with #futurium
  // then show digital content icon
  const isDigitalContent =
    typeTags &&
    typeTags.length > 0 &&
    typeTags.filter(item => {
      return item.title.toLowerCase().startsWith('#futurium');
    }).length > 0;

  return (
    <StyledArticleTeaser
      {...props}
      size={size}
      imageFormat={imageFormat}
      hasCopy={copy}
      fullWidth={fullWidth}
      alignment={alignment}
      id={id}
      data-category={category}
    >
      <Link
        href={{
          pathname: '/universal',
          query: { uri }
        }}
        as={uri}
        className="articleTeaser__link"
        title={headline}
      >
        {pageTags && (
          <FilterTags tags={pageTags} alignRight className="articleTeaser__categories" />
        )}
        <div className="articleTeaser__headlines">
          {isDigitalContent && (
            <DigitalContentIcon className="articleTeaser__icon" width="48px" height="40px" />
          )}
          <div className="articelTeaser__headlines-inner">
            {subline && (
              <Headline tag="h3" subline>
                {subline}
              </Headline>
            )}
            <Headline teaser>{headline}</Headline>
            {!copy && !introCopy && (
              <>
                {typeTags && <Tags className="articleTeaser__tags" limit={3} tags={typeTags} />}
                <div className="articleTeaser__arrow">
                  <LongArrowRight role="presentation" />
                </div>
              </>
            )}
          </div>
        </div>
        {!image && size === 'm' && <div className="articleTeaser__border" />}
        {image ? (
          <div className="articleTeaser__image">
            <div className="articleTeaser__image-wrapper">
              <Image {...image} sizes={imageSizes} />
            </div>
          </div>
        ) : null}
        {copy && (
          <div className="articleTeaser__copy">
            {copy && <Copy>{copy}</Copy>}
            {typeTags && <Tags className="articleTeaser__tags" limit={3} tags={typeTags} />}
            <div className="articleTeaser__arrow">
              <LongArrowRight role="presentation" />
            </div>
          </div>
        )}
        {introCopy && (
          <div className="articleTeaser__copy">
            {introCopy && (
              <MixedCopy
                fullWidth
                html={introCopy.length > 200 ? `${introCopy.substring(0, 200)}...` : introCopy}
              />
            )}
            {typeTags && <Tags className="articleTeaser__tags" limit={3} tags={typeTags} />}
            <div className="articleTeaser__arrow">
              <LongArrowRight role="presentation" />
            </div>
          </div>
        )}
      </Link>
    </StyledArticleTeaser>
  );
};

ArticleTeaser.propTypes = {
  pageTags: PropTypes.arrayOf(PropTypes.shape()),
  typeTags: PropTypes.arrayOf(PropTypes.shape()),
  copy: PropTypes.string,
  introCopy: PropTypes.string,
  headline: PropTypes.string.isRequired,
  image: PropTypes.shape(),
  imageFormat: PropTypes.oneOf(['portrait', 'landscape']),
  size: PropTypes.oneOf(['s', 'm']),
  subline: PropTypes.string,
  uri: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  alignment: PropTypes.string,
  id: PropTypes.number.isRequired,
  category: PropTypes.string
};

export default ArticleTeaser;
